import type { FaireProductEntity } from "../../entity_types/product";

export const p_nkqbfadawr: FaireProductEntity = {
  token: "p_nkqbfadawr",
  type: "product",
  name: "Pretty Petal High Neck Crochet Halter Top",
  brandToken: "b_5xdelgfsdc",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2cec77ff40874a141baad0b706bcb604f17dfea815e86901ff0ee8517bbac525.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c09ebd6db0984e1606611de28f5b97170ca2745b31f3cecc42fabccbccb3979d.png",
  ],
  priceDollars: 15.94,
  description:
    "Get ready to channel your inner flower child with our handmade Pretty Petal High Neck Crochet Halter Top. Handcrafted with love in Thailand, this boho-chic top is a true hippie's dream come true. The intricate crochet detailing and high neck design give it a unique and stylish look that is sure to turn heads wherever you go. The halter style adds a touch of nostalgia, reminiscent of the carefree days of the 60s and 70s. With its free-sized fit, this top embraces all body shapes and sizes, allowing you to feel comfortable and confident. Available in a range of assorted colors, you can choose the one that resonates with your vibrant spirit.",
  tags: [],
  msrpDollars: 31.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:09.596Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
